<div class="container">
  <mat-icon style="width: 45px; height: 45px" [svgIcon]="icon"></mat-icon>
  <p>{{value != null ? value : '-'}}{{unit}}</p>
</div>
